import { createToggleStore } from "@/store/createToggleStore";

const { useStore: useProModalStore } = createToggleStore();

export { useProModalStore };
